import React from 'react';
import classNames from 'classnames';
import { Info } from 'react-feather';
import COLORS from 'constants/colors';
import { Icon } from 'ui';

const InfoTooltip = ({
  tooltip,
  isReactFeatherIcon,
  iconClassName,
  overrideColorOnSecondary,
  placement = 'top',
  noMarginRight,
  noMarginTop,
  disabled = false,
  ...props
}) => (
  <span
    className={classNames('InfoTooltip fz-base d-fi ai-c', {
      'c-brand-gray-light h-c-gray-darker': !overrideColorOnSecondary,
      'InfoTooltip-colorOnSecondary': overrideColorOnSecondary,
      [props.className]: props.className,
    })}
  >
    <button
      type="button"
      className={classNames('u-resetBtn', {
        'h-22': isReactFeatherIcon,
        'mr-0': noMarginRight,
        'd-f': noMarginTop,
      })}
      data-toggle={!disabled && 'tooltip'}
      data-original-title={tooltip}
      data-placement={placement}
      aria-label={tooltip}
    >
      {isReactFeatherIcon ? (
        <Info size="20" color={COLORS.MIDNIGHT_50} />
      ) : (
        <Icon name="info" className={classNames({ 'mt-0': noMarginTop })} />
      )}
    </button>
  </span>
);

export default InfoTooltip;
